import styled from 'styled-components';
import {CSS_CONSTANTS} from '../../../../css_variables';

export const DesignSystemComboBoxOldLookAdapter = styled.div`
	width: 100%;

	div {
		font-family: 'neue-haas-grotesk-text', 'sans-serif';
		color: ${CSS_CONSTANTS.v2_text_light_gray};
		border-color: ${CSS_CONSTANTS.v2_text_light_gray};
		font-size: 9px;
		letter-spacing: 1px;
		font-weight: 500;
	}
`;
